var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 43,
    viewBox: "0 0 65 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1542 19.2805H58.3833V5.96797H39.1542V19.2805ZM48.7688 16.0263L41.5208 10.9971V8.48255L48.7688 13.5117L56.0167 8.48255V10.9971L48.7688 16.0263ZM5.28125 42.7992C3.99931 42.7992 2.93924 42.3801 2.10104 41.5419C1.26285 40.7037 0.84375 39.6437 0.84375 38.3617V4.63672C0.84375 3.35477 1.26285 2.2947 2.10104 1.45651C2.93924 0.618316 3.99931 0.199219 5.28125 0.199219H59.7146C60.9965 0.199219 62.0566 0.618316 62.8948 1.45651C63.733 2.2947 64.1521 3.35477 64.1521 4.63672V38.3617C64.1521 39.6437 63.733 40.7037 62.8948 41.5419C62.0566 42.3801 60.9965 42.7992 59.7146 42.7992H5.28125ZM23.6229 28.3034C25.5458 28.3034 27.1852 27.6254 28.5411 26.2695C29.8971 24.9136 30.575 23.2742 30.575 21.3513C30.575 19.4284 29.8971 17.789 28.5411 16.4331C27.1852 15.0772 25.5458 14.3992 23.6229 14.3992C21.7 14.3992 20.0606 15.0772 18.7047 16.4331C17.3488 17.789 16.6708 19.4284 16.6708 21.3513C16.6708 23.2742 17.3488 24.9136 18.7047 26.2695C20.0606 27.6254 21.7 28.3034 23.6229 28.3034ZM7.5 40.7284H39.7458C37.675 38.3617 35.259 36.4388 32.4979 34.9596C29.7368 33.4805 26.7785 32.7409 23.6229 32.7409C20.4674 32.7409 17.509 33.4805 14.7479 34.9596C11.9868 36.4388 9.57083 38.3617 7.5 40.7284Z",
    fill: "#959DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMail);
export default __webpack_public_path__ + "static/media/contact_mail.15152362391eee4ef163f7b6183c772a.svg";
export { ForwardRef as ReactComponent };